import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment-timezone';
import { liveDataTimeSelector } from '@store/metricLens/liveData/selectors';
import { TimeTablet } from './styled';
// eslint-disable-next-line react/display-name
export default () => {
  const liveData = useSelector(liveDataTimeSelector);

  return (
    <TimeTablet>
      {liveData === null ? (
        <span className="loading-time">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      ) : (
        <div>
          <span className="live-text">Live : </span>
          <span>{moment(liveData).format('DD  MMM, YYYY HH:mm:ss')}</span>
        </div>
      )}
    </TimeTablet>
  );
};
